

import React,{ useEffect, useState } from 'react'
import Logo from '../../folder/images/FidelitusLogo.png'
import {BiLogoFacebook,BiLogoLinkedin} from 'react-icons/bi'
import {AiFillInstagram,AiFillYoutube} from 'react-icons/ai'
import {IoLogoWhatsapp} from 'react-icons/io'
import {IoCloseOutline} from 'react-icons/io5'
import {TbMenu} from 'react-icons/tb'
import {BiSolidArrowFromLeft,BiSolidArrowFromBottom} from 'react-icons/bi';
import { Drawer } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import ScrollToTop from '../../pages/ScrollToTop'
import { fms_website_url, hrlabs_website_url, project_website_url, transaction_website_url } from '../constants/Appconstants'


export default function Navbar() {

  const navigator = useNavigate()
  const {pathname} = useLocation()

  const [openDropdown, setOpenDropdown] = useState(null);
  const [openDropdown1, setOpenDropdown1] = useState(null);
  const [step,setstep] = useState(null)
  const [step1,setstep1] = useState(null)

  const [visible,setvisible] = useState(false)



  useEffect(()=>{
   if(pathname === '/'){
    // router.push('/home')
   }
  },[pathname])
  

  const social_media = [
    {'icon':BiLogoFacebook,name:'Facebook',id:1,path:'https://www.facebook.com/Fidelitus/'},
    {'icon':AiFillInstagram,name:'Instagram',id:2,path:'https://www.instagram.com/fidelitus.corp/'},
    {'icon':BiLogoLinkedin,name:'LinkedIn',id:3,path:'https://in.linkedin.com/company/fidelituscorp-property-services-private-ltd'},
    {'icon':AiFillYoutube,name:'YouTube',id:4,path:'https://youtu.be/y-3CAl8M9yA'},
    {'icon':IoLogoWhatsapp,name:'WhatsApp',id:5,path:'https://api.whatsapp.com/send?phone=919845062227&text=Hi%20I%20would%20like%20to%20connect%20with%20you'},
  ]

  // {name:"Real Estate Transactions Pvt Ltd",path:'/real-estate'},
  // {name:"Projects Pvt Ltd",path:'/projects'},
  // {name:"Facility Managment Services Pvt Ltd",path:'/facility-management-services'},
  // {name:"HR Labs Pvt Ltd",path:'/hr-labs'},
  const menu = [
    {name:'Home',path:'/',id:1,dropdown:[]},
    {name:'About Us',path:'na',id:2,dropdown:[
      {name:'Who we are',path:'/about/our_vision'},
      {name:"Chairman's Message",path:'/about/chairman_message'},
    ]},
    {name:'Why Us',path:'/why-us',id:7,dropdown:[]},
    {name:'Fidelitus Business',path:'na',id:6,dropdown:[
      {name:"Fidelitus Transactions Pvt Ltd",path:transaction_website_url,new:true},
      {name:"Fidelitus Projects Pvt Ltd",path:project_website_url,new:true},
      {name:"Fidelitus Facility Managment Services Pvt Ltd",path:fms_website_url,new:true},
      {name:"Fidelitus HR Labs Pvt Ltd",path:hrlabs_website_url,new:true},
    ]},
    {name:'Blogs',path:'/blogs',id:5,dropdown:[]},
    {name:'Careers',path:'/join_us',id:6,dropdown:[]},
    {name:'Contact Us',path:'/contact',id:4,dropdown:[]},
  
  ]

  const menu1 = [
    // {name:'Services',path:'na',id:2,dropdown:[
    //       {name:"Real Estate Transactions",path:'/real-estate'},
    //       {name:"Projects",path:'/projects'},
    //       {name:"Facility Managment Services",path:'/facility-management-services'},
    //       {name:"HR Labs",path:'/hr-labs'},
    //     ],      
    // },
    {name:'Shilpa Foundation',path:'/shilpa_foundation',id:7,dropdown:[]},
    {name:'Art & Media',path:'/fidelitus_gallery',id:4,dropdown:[]},
  ]

  function movetonewpage(item){
    navigator(item?.path)
    console.log("item kp",item)

  }

  function openPage(v){

    if(v?.new === true){
      window.open(v?.path,'_self')
      setvisible(false)
      setOpenDropdown(null)
    }else{
      navigator(v?.path)
      setvisible(false)
      setOpenDropdown(null)
    }
  }

  function openPage1(v){
    if(v?.new === true){
      window.open(v?.path,"_self")
      setvisible(false)
    }else{
      navigator(v?.path)
      setvisible(false)
    }
  }


  // fixed  shadow-sm 
  return (
    <div className='focus:outline-none  focus:ring-0 z-100'>
    <ScrollToTop />
    <Drawer className='relative focus:outline-none focus:ring-0' open={visible} closable={false} mask={true} onClose={()=>setvisible(!visible)} maskClosable={true} width={280}>
      <div className='relative min-h-[90vh] max-h-[90vh] overflow-y-hidden'>
          <div className='flex justify-between items-center pb-2 border-b mb-2 border-slate-100'>
          <div>
          <img src={Logo} alt="FidelitusHrLab" className='block w-[120px] h-[40px] py-[2px] object-stretch cursor-pointer' />
          <h6 className='font_normal  text-[11px] mt-1 font-[900]'>Fidelitus Corp Pvt Ltd</h6>
          </div>
          <IoCloseOutline size={25} onClick={()=>setvisible(!visible)} />
          </div>

          <div  onClick={()=>{navigator('/');setvisible(!visible)}}  className='border-b my-3 mb-1 pb-1  flex items-center justify-between'>
              <h6 className={`font_normal text-[13px] ${pathname === '/' ? 'text-[#4190ac]' : 'text-slate-900'} font-[500] `}>Home</h6>
              <BiSolidArrowFromLeft color="#4190ac"  /> 
          </div>
          {menu?.map((m,i)=>(
            <div key={i} className='relative'>   
              <div onClick={()=>m?.path == 'na' ? setstep(m?.id) : openPage(m)} key={i}  className='border-b my-3 mb-1 pb-1  flex items-center justify-between'>
                  <h6  className={`font_normal text-[13px] ${m?.path === pathname ? 'text-[#4190ac]' : 'text-slate-900'} font-[500] `}>{m?.name}</h6>
                 {step !== m?.id ?
                  <BiSolidArrowFromLeft color="#4190ac" /> :
                  <BiSolidArrowFromBottom color="#4190ac" />}
              </div>

              {m?.dropdown?.length > 0 && step == m?.id && 
                <div className={`${step == m?.id ? 'block' : 'hidden'}  bg-white`}>
                  {m?.dropdown?.map((m1)=>(
                      <div  onClick={()=>{openPage(m1);setstep(null);setvisible(!visible)}}  className='my-3  flex items-center justify-between border-b pb-2'>    
                        <h6 className={`font_normal text-[13px] ${m1?.path === pathname ? 'text-[#4190ac]' : 'text-slate-900'} font-[500] `}>{m1?.name}</h6>
                        <BiSolidArrowFromLeft color="#4190ac"/>
                      </div>
                 
                  ))}
                </div>
             }
            </div>
          ))}

         {menu1?.map((m,i)=>(
             <div key={i} className='relative'>   
             <div onClick={()=>openPage1(m)} key={i}  className='border-b my-3 mb-1 pb-1  flex items-center justify-between'>
                 <h6  className={`font_normal text-[13px] ${m?.path === pathname ? 'text-[#4190ac]' : 'text-slate-900'} font-[500] `}>{m?.name}</h6>
                {step1 !== m?.id ?
                 <BiSolidArrowFromLeft color="#4190ac" /> :
                 <BiSolidArrowFromBottom color="#4190ac" />}
             </div>

             {m?.dropdown?.length > 0 && step1 == m?.id && 
               <div className={`${step1 == m?.id ? 'block' : 'hidden'}  bg-white`}>
                 {m?.dropdown?.map((m1)=>(
                     <div  onClick={()=>{openPage1(m1);setstep1(null);setvisible(!visible)}}  className='my-3  flex items-center justify-between border-b pb-2'>    
                       <h6 className={`font_normal text-[13px] ${m1?.path === pathname ? 'text-[#4190ac]' : 'text-slate-900'} font-[500] `}>{m1?.name}</h6>
                       <BiSolidArrowFromLeft color="#4190ac"/>
                     </div>
                
                 ))}
               </div>
            }
           </div>
          ))}

          <div className='mt-4'>
          <h6 className='font_normal text-[13px]'>Follow us on</h6>
          <div className='flex h-full mt-4 mr-[9%] -ml-[5%] items-center'>
            {social_media?.map((item,index)=>(
              <a key={item?.id}  className='h-full' href={item?.path} target='_blank'>
               <h6 className={`px-2 flex items-center h-full opacity-60   hover:opacity-100 border-r ${index == 0 && 'border-l'} border-gray-200`}>
               <item.icon  className='cursor-pointer'  />
              </h6>
              </a>
            ))} 
        </div>
          </div>
      </div>

    </Drawer>


    <div className="min-w-screen px-[10%] h-full flex items-center justify-between w-full">
        
        <div className='flex w-fit items-center py-4'>
          <a href="/">
          <img src={Logo}  alt="FidelitusHrLab" className='hidden md:block w-[100%]  h-[45px] object-contain cursor-pointer' />
          </a>

          <div className='pl-5 relative hidden w-max  md:flex items-center justify-between'>
            {menu?.map((m,i)=>(
              <div onMouseLeave={()=>setOpenDropdown1(null)} onMouseOver={()=>m?.dropdown?.length > 0  ? setOpenDropdown1(i) : setOpenDropdown1(null)} key={i} className='group'>
              <h6 onClick={()=>m?.path !== 'na' && navigator(m?.path)} key={m?.id} className={`peer text-black font_bold text-[13px] 2xl:text-[16px] py-2 font-[300] cursor-pointer px-3   `}>{m?.name}</h6>
              {m?.dropdown?.length > 0 && openDropdown1 == i &&
                <div className='absolute top-[32px] z-10 ml-[-17px] bg-white min-w-[230px] py-6'>
                <div className={`${openDropdown1 == i ? 'block' : 'hidden'}  min-w-[230px] `}>
                  <div className='grid grid-cols-1'>
                    {m?.dropdown?.map((m1)=>(
                    <h6 onClick={()=>{openPage1(m1);setOpenDropdown1(null);}} key={m?.id} className={`capitalize hover:text-[#027d9b] text-[12px] 2xl:text-[15px]  py-1 font-[500] text-gray-800 cursor-pointer px-4 relative  font-[600] font_normal `}>{m1?.name}</h6>
                    ))}
                    </div> 
                </div>
                </div> 
              }
              
            </div> 
            ))}
          </div>
        </div>

        <div className='flex items-center justify-center  h-full items-center'>
            {social_media?.map((item,index)=>(
              <a key={item?.id}  className='h-full' href={item?.path} target='_blank'>
               <h6 className={`px-2 flex items-center h-full opacity-60   hover:opacity-100 py-2 border-r ${index == 0 && 'border-l'} border-gray-200`}>
               <item.icon  className='cursor-pointer'  />
              </h6>
              </a>
            ))} 
        </div>

       

    </div>

    <div className='block md:hidden  flex justify-between w-full px-[5%] border-t border-b border-slate-100 w-fit items-center py-4'>
          <a href="/">
          <img src={Logo}  alt="FidelitusHrLab" className='w-[100%]  h-[45px] object-contain cursor-pointer' />
          </a>

          <TbMenu onClick={()=>setvisible(!visible)} />
    </div>  

    </div>
  )
}
